import {
  createFrontendModule,
  NavItemBlueprint,
  coreExtensionData,
  PageBlueprint,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { FolderOpen } from 'lucide-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import {
  compatWrapper,
} from '@backstage/core-compat-api';
import { EntityListProvider } from "@backstage/plugin-catalog-react";

// Create a custom catalog navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:catalog'
const customCatalogNavItem = NavItemBlueprint.make({
  params: {
    title: 'Catalog',
    icon: FolderOpen as IconComponent,
    routeRef: catalogPlugin.routes.catalogIndex,
  },
});

// Apply override to replace the factory function
const customCatalogNavExtension = customCatalogNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

export const catalogPage = PageBlueprint.makeWithOverrides({
  inputs: {
    filters: createExtensionInput([coreExtensionData.reactElement]),
  },
  config: {
    schema: {
      pagination: z =>
        z
          .union([
            z.boolean(),
            z.object({
              mode: z.enum(['cursor', 'offset']),
              limit: z.number().optional(),
              offset: z.number().optional(),
            }),
          ])
          .default(true),
    },
  },
  factory(originalFactory, { inputs }) {
    return originalFactory({
      path: '/catalog',
      routeRef: catalogPlugin.routes.catalogIndex,
      loader: async () => {
        const filters = inputs.filters.map(filter =>
          filter.get(coreExtensionData.reactElement),
        );
        const { CatalogPage } = await import('../components/catalog/CatalogPage');
        return compatWrapper(
            <EntityListProvider>
              <CatalogPage filters={filters} />
            </EntityListProvider> ,
        );
      },
    });
  },
});

// Create a module that contains our custom catalog configurations
// Using 'catalog' as pluginId since we're overriding catalog plugin
export const customCatalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    customCatalogNavExtension, // Custom nav item with better icon
    catalogPage, // Custom catalog page without filters
    // Add more catalog customizations here later
  ],
});